<template>
  <div class="po-actions">
    <div class="listing-title">{{ $t(title) }}</div>
    <div class="listing-actions">
      <TolAltButton label="Export to excel" icon-name="file-excel" @click="setMenuOption($event)" />
      <TolAltButton label="Export to csv" icon-name="file-csv" @click="setMenuOption($event)" />
      <TolAltButton label="Download PDF" icon-name="file-pdf" @click="setMenuOption($event)" />
      <TolAltButton label="Print" icon-name="print" @click="setMenuOption($event)" />
      <Dropdown
        v-show="showSettingsDropdown"
        :menu-items="[
          { label: $t('payrollOverviews.listing.actions.exportAll') },
          { label: $t('payrollOverviews.listing.actions.exportPage') }
        ]"
        class="dropdown-menu-right"
        :parent-left="clickParentLeft"
        @optionClicked="onExportChange($event)"
      />

      <div class="listing-search">
        <tol-type-ahead
          :search-params="{
            url: '/payroll-overviews',
            searchKeys: ['searchParam'],
            urlParams
          }"
          :icon-config="{ label: 'search' }"
          :results-in-dropdown="false"
          :no-clear-search="true"
          @filtered="onFiltered($event)"
        >
        </tol-type-ahead>
      </div>
    </div>
  </div>
</template>

<script>
import TolAltButton from '@/app/components/TolAltButton';
import TolTypeAhead from '@/app/components/TolTypeAhead';
import Dropdown from '@/app/components/Dropdown';
import {
  PayrollOverviewsListingActions,
  PayrollOverviewsListingGetters
} from '../payroll-overviews-listing.keys';

export default {
  name: 'PayrollOverviewsActions',
  components: { TolAltButton, TolTypeAhead, Dropdown },
  props: {
    title: {
      type: String,
      default: 'payrollOverviews.listing.actions.titleAll'
    }
  },
  data() {
    return {
      showSettingsDropdown: false,
      clickParentLeft: null,
      selectedOption: null
    };
  },
  computed: {
    sortParams() {
      return this.$store.getters[PayrollOverviewsListingGetters.PayrollOverviewsSortOrder];
    },
    paginationParams() {
      return this.$store.getters[PayrollOverviewsListingGetters.PayrollOverviewsPaginationParams];
    },
    urlParams() {
      return {
        ...this.sortParams,
        ...this.paginationParams
      };
    }
  },
  methods: {
    async onFiltered(event) {
      this.$emit('filter', { isBeingFiltered: true });
      await this.$store.dispatch(PayrollOverviewsListingActions.FilterListBySearchKey, {
        filteredItems: event.data,
        isSearchKey: event.isSearchKey,
        searchParam: event.searchParam
      });
      this.$emit('filter', { isBeingFiltered: false });
    },
    onExportChange(event) {
      const action = { action: this.selectedOption, ...event };
      this.$store.dispatch(PayrollOverviewsListingActions.ExportList, action);
      this.showSettingsDropdown = false;
    },
    setMenuOption(el) {
      if (this.showSettingsDropdown) {
        this.showSettingsDropdown = false;
        this.showSettingsDropdown = true;
      } else {
        this.showSettingsDropdown = true;
      }
      this.clickParentLeft = el.$el.offsetLeft;
      this.selectedOption = el.$el.innerText;
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';

.po-actions {
  display: flex;
  flex-direction: column;
  //align-items: center;
  background-color: $background-level-2;
  padding: 60px;
  .listing-title {
    color: $text-color-dark;
    font-size: 24px;
    font-weight: bold;
    letter-spacing: -0.24px;
    line-height: 28px;
  }

  .listing-actions {
    display: flex;
    flex-direction: column;
    position: relative;

    @media only screen and (min-width: 768px) {
      flex-direction: row;
    }

    .wrapper {
      margin-right: 3px;
    }
    padding: 15px 0;
    .listing-search {
      margin-left: auto;
      width: 100%;

      @media only screen and (min-width: 768px) {
        width: 350px;
      }
    }
  }
}
</style>
